import {
  IpAddress,
  ISO3166Alpha2,
  USAState,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const GeoIpDto = z.object({
  ip: IpAddress,
  country: ISO3166Alpha2,
  country_name: z.string().min(1),
  region: USAState,
  region_code: USAStateAcronym,
  city: z.string().min(1),
  postal: ZipCode,
  loc: z.string().min(1),
});

// eslint-disable-next-line no-redeclare
export type GeoIpDto = z.infer<typeof GeoIpDto>;
